import Game from "./scenes/Game";
import Intro from "./scenes/Intro";
import PopBubbleScreen from "./scenes/PopBubbleScreen";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, Game, PopBubbleScreen],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,
    //startScene: Game.KEY,
    //startScene: PopBubbleScreen.KEY,

    CURRENT_LEVEL:1,
    BEST_BONUS_TIME:99999
}
